// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ag-header-cell-filtered {
  background-color: #0071e3 !important;
  color: #fff !important;
}

.ag-header-cell-filtered span {
  color: #fff !important;
}

.ag-cell {
  display: flex;
  align-items: center;
}

/* Needed to enable text selection in ag-grid table */
div.ag-root .ag-cell-focus {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}

.ag-cell-wrapper {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/OrdersTable/orderTable.styles.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,qDAAqD;AACrD;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".ag-header-cell-filtered {\n  background-color: #0071e3 !important;\n  color: #fff !important;\n}\n\n.ag-header-cell-filtered span {\n  color: #fff !important;\n}\n\n.ag-cell {\n  display: flex;\n  align-items: center;\n}\n\n/* Needed to enable text selection in ag-grid table */\ndiv.ag-root .ag-cell-focus {\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n}\n\n.ag-cell-wrapper {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
